

  <div class="modal-container">
    <div class="modal-header" [ngClass]="{'warning': confirmationType() === 'warning'}">
      <h3>{{ headerText() }}</h3>
      <button class="close-button" (click)="onCancel()">
        <mat-icon >close</mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <div>{{ bodyText() }}</div>
      <div>{{ confirmButtonWarningMessage() }}</div>
    </div>
    <div class="modal-footer">
      <button class="cancel-button" (click)="onCancel()">{{ cancelButtonText() }}</button>
      <button class="confirm-button" (click)="onConfirm()">{{ confirmButtonText() }}</button>
    </div>
  </div>
